import { Outlet } from 'react-router';

/**
 * Wrapper layout for the carrier-dashboard order-creation flow.
 *
 * Thin shell that fills the dashboard content area; the actual 60/40
 * split (form on the left, sticky map + live summary on the right) is
 * owned by the variant components themselves so the same composition
 * can ship to customer-dashboard later without coupling to this layout.
 */
export default function OrderLayout() {
  return (
    <div className="h-[85dvh]">
      <Outlet />
    </div>
  );
}
